// storeRegistry.ts
export const storeResetFns = new Set<() => void>();

export const resetAllStores = () => {
  storeResetFns.forEach((reset) => reset());
};

export const clearLocalStorage = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.clear();
};
